export default "__VITE_ASSET__CIVNJC2u__"